import React from 'react';
import api from '../../../api.js';
import _ from 'lodash';
import { Link } from "react-router-dom";
import { Carousel } from 'react-bootstrap';
import LandingPage from './landingPage.js';

class Grid extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pubRoots: props.pubRoots,
      landing: null,
      breadcrumb: props.breadcrumb,
      selectedToc: props.selectedToc,
      blobMap: {}
    };
    
    this.env = api.getEnv();
    this.domain = api.getDomain();
    this.subdomain = api.getSubdomain();
    this.queue = [];
    this.tileIndex = 0;
  }

  isEqual = (arr1, arr2) => {
    if (arr1 === null && arr1 === arr2) {
      return true;
    }
    if (arr1 === null && arr1 !== arr2) {
      return false;
    }
    if (arr2 === null && arr1 !== arr2) {
      return false;
    }
    if (arr1.length !== arr2.length) return false;
    else if (arr1.length === 0) return true;
    else {
      if (arr1[0].rootNode.element.id.data.exhibitionId === arr2[0].rootNode.element.id.data.exhibitionId) {
        return true;
      } else {
        return false;
      }
    }
  }
  isEqual2 = (arr1, arr2) => {
    if (arr1 === null && arr1 === arr2) {
      return true;
    }
    if (arr1 === null && arr1 !== arr2) {
      return false;
    }
    if (arr2 === null && arr1 !== arr2) {
      return false;
    }
    if (arr1.length !== arr2.length) return false;
    else if (arr1.length === 0) return true;
    else {
      let notEqual = false;
      arr1.forEach((e, i) => notEqual = notEqual === true ? true : arr2[i] !== arr1[i]);
      return !notEqual;
    }
  }

  writeBreadCrumb = (title, url) => {
    return <Link to={"/search" + url}>{title}</Link>
  }

  drawTile = (item, eId, res = "thumbnail") => {
    const size = "presentation";
    const element = item.element;
    const children = item.children;
    const coverInfo = this.getTileInfo(children);
    let bgImage, cname;
    if (coverInfo.ytvideo) {
      bgImage = "url(https://i.ytimg.com/vi/" + coverInfo.ytvideo + "/maxresdefault.jpg)";
      cname = "tile article yt";
    } else if (coverInfo.image) {
      cname = "tile article";

      if (!this.state.blobMap[coverInfo.image + ' ' + size]) {
        this.setState(prevState => ({
          blobMap: {
            ...prevState.blobMap,
            [coverInfo.image + ' ' + size]: "test"
          }
        }));
        api.getResource(eId, coverInfo.image, size).then(res => {
          if (this.state.blobMap[coverInfo.image + ' ' + size] === "test") {
            this.setState(prevState => ({
              blobMap: {
                ...prevState.blobMap,
                [coverInfo.image + ' ' + size]: "url(" + URL.createObjectURL(res.data) + ")"
              }
            }));
          }
        });
      }
    } else if (coverInfo.audio) {
      bgImage = "url(https://cdn-icons-png.flaticon.com/512/7412/7412958.png)";
      cname = "tile article podcast";
    } else if (coverInfo.pdf) {
      bgImage = "url(https://cdn-icons-png.flaticon.com/512/6711/6711921.png)";
      cname = "tile article document";
    } else {
      bgImage = "url(background.jpg)";
      cname = "tile article nocover";
    }
    const cover = <div key={element.id.data.valueCellId} className={cname}
      style={{ backgroundImage: bgImage ? bgImage : this.state.blobMap[coverInfo.image + ' ' + size] }} >
      <div className='header'>
        <b><span>
          {coverInfo.name}</span></b>
      </div>
      {/* {coverInfo.ytvideo && <Suspense fallback={<div>Loading component...</div>}>
        <ReactPlayer src={`https://www.youtube.com/watch?v=${coverInfo.ytvideo}`}
          playsInline="true"
          width="100%"
          height="100%"
          light={true}
          className='yt-video-player'
          playing={true} />
      </Suspense>} */}
    </div>
    return cover;
  }

  drawLinkedTile = (item, url, eId, res = "thumbnail") => {
    const size = "presentation";
    const element = item.element;
    const children = item.children;
    const coverInfo = this.getTileInfo(children);
    let bgImage, cname;
    if (coverInfo.ytvideo) {
      bgImage = "url(https://i.ytimg.com/vi/" + coverInfo.ytvideo + "/maxresdefault.jpg)";
      cname = "tile article yt";
    } else {
      cname = "tile article";
      if (!this.state.blobMap[coverInfo.image + ' ' + size]) {
        this.setState(prevState => ({
          blobMap: {
            ...prevState.blobMap,
            [coverInfo.image + ' ' + size]: "test"
          }
        }));
        api.getResource(eId, coverInfo.image, size).then(res => {
          if (this.state.blobMap[coverInfo.image + ' ' + size] === "test") {
            this.setState(prevState => ({
              blobMap: {
                ...prevState.blobMap,
                [coverInfo.image + ' ' + size]: "url(" + URL.createObjectURL(res.data) + ")"
              }
            }));
          }
        });
      }
    }
    let cover = null;
    // if (coverInfo.ytvideo) {
    //   cover =
    //     <div key={element.id.data.valueCellId} className="tile poster article"
    //       style={{ backgroundImage: bgImage ? bgImage : this.state.blobMap[coverInfo.image + ' ' + size] }} >
    //       <div className='header'>
    //         <b><span>
    //           {coverInfo.name}</span></b>
    //       </div>
    //       <Suspense fallback={<div>Loading component...</div>}>
    //         <ReactPlayer src={`https://www.youtube.com/watch?v=${coverInfo.ytvideo}`}
    //           playsInline="true"
    //           width="100%"
    //           height="100%"
    //           light={true}
    //           className='yt-video-player'
    //           playing={true} />
    //       </Suspense>
    //     </div>
    // } else {
      cover = cover = <Link className={cname} to={"/search" + url}>
        <div key={element.id.data.valueCellId} className="poster"
          style={{ backgroundImage: bgImage ? bgImage : this.state.blobMap[coverInfo.image + ' ' + size] }}>
          <div className='header'>
            <b><span>
              {coverInfo.name}</span></b>
          </div>
        </div>
      </Link>
    // }
    return cover;
  }

  openArticle = (aId, eId) => {
    this.props.selectArticle([aId], eId);
  }

  getTileInfo = (children, tileInfo = {}) => {
    children.forEach(ch => {
      if (ch.element.content.data.attribute === "name") {
        tileInfo.name = ch.element.content.data.value.name;
      } else if (!tileInfo.image && (ch.element.content.data.attribute === "image")) {
        tileInfo.image = ch.element.content.data.value.href;
      } else if (!tileInfo.ytvideo && ch.element.content.data.attribute === "youtube") {
        tileInfo.ytvideo = ch.element.content.data.value.id;
      } else if (!tileInfo.ytvideo && !tileInfo.image && ch.element.content.data.attribute === "document") {
        const url = ch.element.content.data.value.href;
        const type = url.substring(21, url.indexOf(","));
        if (type === "pdf") {
          tileInfo.pdf = url
        } else {
          tileInfo.audio = url;
        }
      } else if (ch.element.contentType.type === "Section") {
        this.getTileInfo(ch.children, tileInfo)
      } else if (ch.element.content.data.attribute === "link") {
        // New youtube links
        const uri = ch.element.content.data.value.uri;
        const shortsIndex = uri.indexOf("/shorts/");
        if (shortsIndex < 0) {
          tileInfo.ytvideo = uri.substring(uri.indexOf("?v=") + 3);
        } else {
          tileInfo.ytvideo = uri.substring(shortsIndex + 8)
        }
      }
    })
    return tileInfo;
  }

  processSelection = (child, eId, toc, catPage = false, parentUrl, carouselTileIndex = -1) => {
    let url = parentUrl;
    if (catPage === false) {
      url = "/" + toc.url;
    }
    if (toc.item.data.classification) {
      const articles = toc.children.filter(child => child.item.type === "Content");
      const subCats = toc.children.filter(child => child.item.type === "Classification");
      let catCover = [];

      if (articles.length) {
        let tocItems = [];
        if (catPage) {
          tocItems = toc.children;
        } else {
          tocItems = _.take(toc.children, 4);
        }
        const tileArray = tocItems.map((tocItem, i) => {
          const thisArt = child.children.find(c => c.element.id.data.valueCellId === tocItem.item.data.contentId?.data.valueCellId)
          let cover = '';
          if (thisArt) {
            if (thisArt.children[1]?.element.id.type === "InstanceCell") {
              if (catPage) {
                cover = this.drawLinkedTile(thisArt.children[1], url + "/" + tocItem.url, eId, "presentation");
              } else {
                cover = this.drawTile(thisArt.children[1], eId, i === 0 ? "presentation" : "thumbnail")
              }
            } else {
              if (catPage) {
                cover = this.drawLinkedTile(thisArt, url + "/" + tocItem.url, eId, "presentation");
              } else {
                cover = this.drawTile(thisArt, eId, i === 0 ? "presentation" : "thumbnail");
              }
            }
          }
          return cover;
        }).filter(i => i !== '');
        if (catPage) {
          catCover = tileArray;
        } else if (carouselTileIndex === this.tileIndex) {
          const carouselItems = tileArray;
          catCover = <div className="tile category board carousel-visuals">
            <Carousel className="carousel" wrap={true} interval={null}>{carouselItems}</Carousel></div>
          this.tileIndex++;
        } else {
          catCover = [<div className='tile category' ><Link to={"/search/" + toc.url}>
            <div className='header cat-header'><b>
              <span> {toc.item.data.classification}</span>
            </b></div>{tileArray}
          </Link>
          </div>]
          this.tileIndex++;
        }
      }
      if (subCats.length > 0) {
        const catTiles = subCats.map(subCat => {
          const artSlivers = _.take(subCat.children, 4).map((sc, i) => {
            const thisArt = child.children.find(c => c.element.id.data.valueCellId === sc.item.data.contentId?.data.valueCellId)
            if (thisArt) {
              const cover = this.drawTile(thisArt, eId, i === 0 ? "presentation" : "thumbnail");
              return cover;
            } else {
              return '';
            }
          });
          this.tileIndex++;
          if (this.tileIndex - 1 === carouselTileIndex) {
            return <div className="tile category board carousel-visuals">
              <div className='header cat-header'><b>
                <span> {subCat.item.data.classification}</span>
              </b></div>
              <Carousel className="carousel" wrap={true} interval={null}>
                {artSlivers}
              </Carousel>
            </div>
          } else {

            return <div className='tile category'>
              <Link to={"/search" + url + "/" + subCat.url}><div className='header cat-header'><b>
                <span> {subCat.item.data.classification}</span>
              </b></div>{artSlivers}</Link></div>
          }

        })
        catCover.push(catTiles)
      }
      return catCover;
    }
  }

  getContentForTocItem = (root, category) => {
    const content = root.children.filter(ch => {
      return ch.children.filter(chil => {
        return chil.element.classifications.indexOf(category.item.data.classification) > -1
      }).length > 0;
    });
    if (content.length > 1) {
      const surfaceContent = content.filter(ch => {
        return ch.children[0].element.classifications.includes(category.item.data.classification);
      })
      return surfaceContent;
    } else {
      return content
    }
  }

  generateLanding = (pubRoots, selectedToc, url = this.props.url) => {
    this.tileIndex = 0;
    if (selectedToc) {
      const eId = pubRoots[0].rootNode.element.id.data.exhibitionId;
      const content = this.getContentForTocItem(pubRoots[0].rootNode, selectedToc);
      return this.processSelection(content[0], eId, selectedToc, true, url)
    }
    else {
      let landing = '';
      const grid = pubRoots.map((item, i) => {
        const eId = item.rootNode.element.id.data.exhibitionId;
        const pubName = item.rootNode.element.content.data.value;
        const categories = item.tableOfContents;
        if (this.props.mastheadPub === pubName) {
          landing = <LandingPage
            landingPage={item}
            clickLink={(link) => this.props.history.push("/search/" + link.replace("|", "/"))}
            env={this.props.env}
            eId={eId}
          />
          return '';
        } else {

          const tileArrays = categories.map((category, i) => {

            const content = this.getContentForTocItem(item.rootNode, category);
            if ((this.props.layout === "ABC")) {
              const carouselTileIndex = -1;

              return this.processSelection(content[0], eId, category, false, url, carouselTileIndex)
            } else {
              return this.processSelection(content[0], eId, category, false, url);
            }
          })
          return tileArrays;
        }
      })
      return <React.Fragment>{landing}{grid}</React.Fragment>
    }
  }

  searchContext = (children, cId) => {
    this.queue.push(...children);
    while (this.queue.length > 0) {
      const child = this.queue.shift();
      if (child.element.id.data.valueCellId === cId) {
        this.searchResult = child;
        this.queue.length = 0;
      } else {
        this.searchContext(child.children, cId);
      }
    }
  }

  selectArticle = (cId) => {
    this.queue = [];
    this.searchResult = null;
    this.searchContext(this.props.pubRoots[0].rootNode.children, cId);
    return this.searchResult;
  }

  render() {
    return (
      <div className={`board-container landing-page grid ${this.props.layout}`}>
        {this.generateLanding(this.props.pubRoots, this.props.selectedToc)}
        <hr style={{ width: "100%", visibility: "hidden" }} />
        {/* <TMFooter /> */}
      </div>
    )
  }
}

export default Grid;